import { IconProps } from '@euler/app/components/icons/types';
import { FC, memo } from 'react';
import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg';

export const DefectiveIcon: FC<IconProps> = memo(
  ({ width, height, size, color, style }) => {
    return (
      <Svg
        width={width ?? size}
        height={height ?? size}
        viewBox="0 0 36 36"
        fill="none"
        style={style}
      >
        <G clipPath="url(#clip0_381_1617)">
          <Path
            d="M31.7652 9.02813L23.1188 0.377679C22.8777 0.136607 22.5482 0 22.2067 0H5.14286C4.4317 0 3.85715 0.574554 3.85715 1.28571V34.7143C3.85715 35.4254 4.4317 36 5.14286 36H30.8571C31.5683 36 32.1429 35.4254 32.1429 34.7143V9.93616C32.1429 9.59464 32.0063 9.2692 31.7652 9.02813ZM29.1777 10.5268H21.6161V2.96518L29.1777 10.5268ZM29.25 33.1071H6.75V2.89286H18.8839V11.5714C18.8839 12.019 19.0617 12.4482 19.3782 12.7647C19.6947 13.0811 20.1239 13.2589 20.5714 13.2589H29.25V33.1071ZM13.5804 19.4866C13.5804 19.7036 13.7571 19.8683 13.9741 19.8683H15.2759C15.4929 19.8683 15.6696 19.6996 15.6696 19.4906C15.6696 18.3576 16.7063 17.4174 18 17.4174C19.2938 17.4174 20.3304 18.3576 20.3304 19.4866C20.3304 20.5031 19.4866 21.383 18.3496 21.5317C17.5741 21.6442 16.9634 22.3473 16.9554 23.1429V24.4286C16.9554 24.6496 17.1362 24.8304 17.3571 24.8304H18.6429C18.8638 24.8304 19.0446 24.6496 19.0446 24.4286V23.9384C19.0446 23.6973 19.2054 23.4763 19.4344 23.404C21.2263 22.8254 22.4478 21.2344 22.4196 19.4304C22.3875 17.2004 20.4429 15.3804 18.0603 15.3482C15.5933 15.3201 13.5804 17.1804 13.5804 19.4866ZM16.7143 27.3214C16.7143 27.6624 16.8498 27.9894 17.0909 28.2306C17.332 28.4717 17.659 28.6071 18 28.6071C18.341 28.6071 18.668 28.4717 18.9091 28.2306C19.1503 27.9894 19.2857 27.6624 19.2857 27.3214C19.2857 26.9804 19.1503 26.6534 18.9091 26.4123C18.668 26.1712 18.341 26.0357 18 26.0357C17.659 26.0357 17.332 26.1712 17.0909 26.4123C16.8498 26.6534 16.7143 26.9804 16.7143 27.3214Z"
            fill={color}
          />
        </G>
        <Defs>
          <ClipPath id="clip0_381_1617">
            <Rect width="36" height="36" fill="white" />
          </ClipPath>
        </Defs>
      </Svg>
    );
  },
);
